/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdFinancialData200,
  GetApiV1PersonIdFinancialData401,
  GetApiV1PersonIdFinancialData404,
  GetApiV1PersonIdFinancialData500,
  GetApiV1PersonIdFinancialDataPathParams,
  GetApiV1PersonIdFinancialDataQueryResponse,
} from "../../types/personFinancialController/GetApiV1PersonIdFinancialData.ts";
import { personFinancialDataViewModelSchema } from "../personFinancialDataViewModelSchema.ts";

export const getApiV1PersonIdFinancialDataPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1PersonIdFinancialDataPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdFinancialData200Schema = z.lazy(
  () => personFinancialDataViewModelSchema,
) as unknown as ToZod<GetApiV1PersonIdFinancialData200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdFinancialData401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdFinancialData401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdFinancialData404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdFinancialData404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdFinancialData500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdFinancialData500>;

export const getApiV1PersonIdFinancialDataQueryResponseSchema = z.lazy(
  () => getApiV1PersonIdFinancialData200Schema,
) as unknown as ToZod<GetApiV1PersonIdFinancialDataQueryResponse>;
